import { DOMParser } from 'hubspot-prosemirror/pm/model';
import { convertToPlaintextState } from '../../utils/plaintextUtils';
import { getFullUrl } from 'hubspot-url-utils';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import PortalIdParser from 'PortalIdParser';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export const initContentAssistantSlashPluginState = () => {
  return {
    dropdownActive: false,
    popoverActive: false,
    searchTerm: '',
    searchTextStartPos: 0,
    currentCursorPos: 0,
    currentDropdownIndex: -1
  };
};
export function mapEditorContext(state) {
  const plain = convertToPlaintextState(state);
  const precedingText = plain.doc.textBetween(0, plain.selection.from, '\n');
  const selectedText = plain.doc.textBetween(plain.selection.from, plain.selection.to, '\n');
  const rest = plain.doc.textBetween(plain.selection.from, plain.doc.content.size, '\n').replace(selectedText, `<<${selectedText}>>`);
  return `${precedingText}${rest}`;
}
export const onInsertSlashContent = (text, view, state, commandId, tr) => {
  let node;
  switch (commandId) {
    case 'inbox_write_for_me_v1':
      {
        node = view.state.schema.text(text);
        break;
      }
    default:
      {
        const html = `${text.replaceAll('\n', '<br>')}`;
        const parser = new window.DOMParser();
        const element = parser.parseFromString(html, 'text/html');
        node = DOMParser.fromSchema(view.state.schema).parse(element.body);
      }
  }
  tr.replaceWith(state.searchTextStartPos, state.currentCursorPos, node);
  view.dispatch(tr);
};
export const getSelectedCommandParamsForSlash = (selectedCommand, __view, __state) => {
  const parameters = {};
  switch (selectedCommand) {
    case 'inbox_write_for_me_v1':
      {
        const title = document.querySelector('#composition-title');
        if (title && title.value) {
          parameters.title = title.value;
        }
        break;
      }
    default:
      break;
  }
  return parameters;
};
export const getDisabledTooltip = (option, globalSummarizationEnabled, summarizationDisabledMessage) => {
  const settingsUrl = `${getFullUrl('app')}/ai-settings/${PortalIdParser.get()}`;
  if (option.id === 'generate_summary' && !globalSummarizationEnabled) {
    return summarizationDisabledMessage || /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'hubspot-prosemirror.tooltips.customerAnalysisSettingOff_jsx',
      elements: {
        Link
      },
      options: {
        href: settingsUrl,
        external: true
      }
    });
  }
  return null;
};